import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSavedJobStateMutationVariables = Types.Exact<{
    input: Types.UpdateSavedJobStateInput;
}>;

export type UpdateSavedJobStateMutation = {
    __typename?: 'Mutation';
    updateSavedJobState?:
        | {
              __typename?: 'UpdateSavedJobStatePayload';
              savedJob: { __typename?: 'SavedJob'; state: Types.SavedJobState };
          }
        | null
        | undefined;
};

export type GetAutoApplyScreenerPrefillStateQueryVariables = Types.Exact<{
    input: Types.SmartApplyContextInput;
}>;

export type GetAutoApplyScreenerPrefillStateQuery = {
    __typename?: 'Query';
    smartApplyContext?:
        | {
              __typename?: 'SmartApplyContext';
              draftId: string;
              screenerQuestionContext?:
                  | {
                        __typename?: 'SmartApplyScreenerQuestionContext';
                        screenerQuestions: Array<{
                            __typename?: 'ScreenerQuestionContextQuestion';
                            id: string;
                            name: string;
                            type: Types.SmartApplyScreenerQuestionType;
                            formField:
                                | {
                                      __typename: 'ScreenerQuestionContextFileFormField';
                                      fileSlots: Array<{
                                          __typename?: 'ScreenerQuestionContextFileFormFieldSlot';
                                          slotValue: string;
                                      }>;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextHierarchicalFormField';
                                      entries: Array<{
                                          __typename?: 'ScreenerQuestionContextHierarchicalFormFieldEntry';
                                          key: string;
                                          entryValue: string;
                                      }>;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextMultiFieldFormField';
                                      _unused?: boolean | null | undefined;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextMultiValuedFormField';
                                      values: Array<string>;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextSingleValuedFormField';
                                      textValue?: string | null | undefined;
                                  };
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export type CreateAutoApplyPreviewMutationVariables = Types.Exact<{
    input: Types.CreatePreviewInput;
    smartApplyApplicationStateInput: Types.SmartApplyApplicationStateInput;
}>;

export type CreateAutoApplyPreviewMutation = {
    __typename?: 'Mutation';
    smartApplyApplicationState: {
        __typename?: 'SmartApplyApplicationStateMutations';
        createPreview?:
            | {
                  __typename?: 'CreatePreviewSmartApplyApplicationStatePayload';
                  previewHtml?: string | null | undefined;
                  errorCode?: Types.ApplyPreviewErrorCode | null | undefined;
                  previewId?: string | null | undefined;
                  encryptedApplicationId?: string | null | undefined;
                  previewHtmlContentHash?: string | null | undefined;
                  previewHtmlFileToken?: string | null | undefined;
                  resumeType?: Types.ApplyResumeType | null | undefined;
              }
            | null
            | undefined;
    };
};

export const UpdateSavedJobStateDocument = gql`
    mutation UpdateSavedJobState($input: UpdateSavedJobStateInput!) {
        updateSavedJobState(input: $input) {
            savedJob {
                state
            }
        }
    }
`;
export type UpdateSavedJobStateMutationFn = Apollo.MutationFunction<
    UpdateSavedJobStateMutation,
    UpdateSavedJobStateMutationVariables
>;

/**
 * __useUpdateSavedJobStateMutation__
 *
 * To run a mutation, you first call `useUpdateSavedJobStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedJobStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedJobStateMutation, { data, loading, error }] = useUpdateSavedJobStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSavedJobStateMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateSavedJobStateMutation,
        UpdateSavedJobStateMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<UpdateSavedJobStateMutation, UpdateSavedJobStateMutationVariables>(
        UpdateSavedJobStateDocument,
        options,
    );
}
export type UpdateSavedJobStateMutationHookResult = ReturnType<
    typeof useUpdateSavedJobStateMutation
>;
export type UpdateSavedJobStateMutationResult = Apollo.MutationResult<UpdateSavedJobStateMutation>;
export type UpdateSavedJobStateMutationOptions = Apollo.BaseMutationOptions<
    UpdateSavedJobStateMutation,
    UpdateSavedJobStateMutationVariables
>;
export const GetAutoApplyScreenerPrefillStateDocument = gql`
    query GetAutoApplyScreenerPrefillState($input: SmartApplyContextInput!) {
        smartApplyContext(input: $input) {
            draftId
            screenerQuestionContext {
                screenerQuestions {
                    id
                    name
                    type
                    formField {
                        __typename
                        ... on ScreenerQuestionContextSingleValuedFormField {
                            textValue
                        }
                        ... on ScreenerQuestionContextMultiValuedFormField {
                            values
                        }
                        ... on ScreenerQuestionContextHierarchicalFormField {
                            entries {
                                key
                                entryValue
                            }
                        }
                        ... on ScreenerQuestionContextFileFormField {
                            fileSlots {
                                slotValue
                            }
                        }
                        ... on ScreenerQuestionContextMultiFieldFormField {
                            _unused
                        }
                    }
                }
            }
        }
    }
`;

/**
 * __useGetAutoApplyScreenerPrefillStateQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyScreenerPrefillStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyScreenerPrefillStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyScreenerPrefillStateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAutoApplyScreenerPrefillStateQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAutoApplyScreenerPrefillStateQuery,
        GetAutoApplyScreenerPrefillStateQueryVariables
    > &
        (
            | { variables: GetAutoApplyScreenerPrefillStateQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAutoApplyScreenerPrefillStateQuery,
        GetAutoApplyScreenerPrefillStateQueryVariables
    >(GetAutoApplyScreenerPrefillStateDocument, options);
}
export function useGetAutoApplyScreenerPrefillStateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyScreenerPrefillStateQuery,
        GetAutoApplyScreenerPrefillStateQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAutoApplyScreenerPrefillStateQuery,
        GetAutoApplyScreenerPrefillStateQueryVariables
    >(GetAutoApplyScreenerPrefillStateDocument, options);
}
export function useGetAutoApplyScreenerPrefillStateSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplyScreenerPrefillStateQuery,
              GetAutoApplyScreenerPrefillStateQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAutoApplyScreenerPrefillStateQuery,
        GetAutoApplyScreenerPrefillStateQueryVariables
    >(GetAutoApplyScreenerPrefillStateDocument, options);
}
export type GetAutoApplyScreenerPrefillStateQueryHookResult = ReturnType<
    typeof useGetAutoApplyScreenerPrefillStateQuery
>;
export type GetAutoApplyScreenerPrefillStateLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplyScreenerPrefillStateLazyQuery
>;
export type GetAutoApplyScreenerPrefillStateSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyScreenerPrefillStateSuspenseQuery
>;
export type GetAutoApplyScreenerPrefillStateQueryResult = Apollo.QueryResult<
    GetAutoApplyScreenerPrefillStateQuery,
    GetAutoApplyScreenerPrefillStateQueryVariables
>;
export const CreateAutoApplyPreviewDocument = gql`
    mutation CreateAutoApplyPreview(
        $input: CreatePreviewInput!
        $smartApplyApplicationStateInput: SmartApplyApplicationStateInput!
    ) {
        smartApplyApplicationState(input: $smartApplyApplicationStateInput) {
            createPreview(input: $input) {
                previewHtml
                errorCode
                previewId
                encryptedApplicationId
                previewHtmlContentHash
                previewHtmlFileToken
                resumeType
            }
        }
    }
`;
export type CreateAutoApplyPreviewMutationFn = Apollo.MutationFunction<
    CreateAutoApplyPreviewMutation,
    CreateAutoApplyPreviewMutationVariables
>;

/**
 * __useCreateAutoApplyPreviewMutation__
 *
 * To run a mutation, you first call `useCreateAutoApplyPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoApplyPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoApplyPreviewMutation, { data, loading, error }] = useCreateAutoApplyPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *      smartApplyApplicationStateInput: // value for 'smartApplyApplicationStateInput'
 *   },
 * });
 */
export function useCreateAutoApplyPreviewMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateAutoApplyPreviewMutation,
        CreateAutoApplyPreviewMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateAutoApplyPreviewMutation,
        CreateAutoApplyPreviewMutationVariables
    >(CreateAutoApplyPreviewDocument, options);
}
export type CreateAutoApplyPreviewMutationHookResult = ReturnType<
    typeof useCreateAutoApplyPreviewMutation
>;
export type CreateAutoApplyPreviewMutationResult =
    Apollo.MutationResult<CreateAutoApplyPreviewMutation>;
export type CreateAutoApplyPreviewMutationOptions = Apollo.BaseMutationOptions<
    CreateAutoApplyPreviewMutation,
    CreateAutoApplyPreviewMutationVariables
>;
